import React from "react";
import styled from "styled-components";
import { palette, size } from "styled-theme";

const _ValidationMessage = ({errorMessage, className}) => {
  const showErrorMessage = !!errorMessage;
  if (!showErrorMessage) {
    return null;
  }
  
  return (
    <div className={`${className} validation-message`} data-validation-scroll-target>
      { errorMessage }
    </div>
  );
};

export const ValidationMessage = styled(_ValidationMessage)`
  padding-left: 1px;
  color: ${palette("color", 18)};
  font-size: ${size("validationFontSize")};
  position: absolute;
  top: 66px;
  margin-top: 5px;
`;